import * as types from './constants'
import api from '../_api'
// import { apiGetListSchoolType } from "../_api";
import router from '@/router'
import { getAuth, saveAuth } from '@/utils/jwt'
import Vue from 'vue'


const actionGetListTypeSchool = ({ commit }, params = {}) => {
    return api.apiGetListSchoolType(params)
        .then((response) => {
            commit(types.GET_LIST_TYPE_SCHOOL, response.data);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const getUserProfile = ({ commit }, params = {}) => {
    api.getUserProfile(params)
        .then((res) => {
            commit(types.GET_USER_PROFILE, res.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetAllProvince = ({ commit }, params = {}) => {
    return api.getAllProvince(params)
        .then((response) => {
            commit(types.GET_ALL_PROVICE, response.data);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetTypePractice = ({ commit }, params = {}) => {
    return api.getTypePractice(params)
        .then((response) => {
            commit(types.GET_TYPE_PRACTICE, response.data);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetBookGroup = ({ commit }, params = {}) => {
    return api.getBookGroup(params)
        .then((response) => {
            commit(types.GET_BOOK_GROUP, response.data);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetSubjects = ({ commit }, params = {}) => {
    return api.getSubjects(params)
        .then((response) => {
            commit(types.GET_SUBJECT, response.data.subjects);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetListProcessLearning = ({ commit }, params = {}) => {
    return api.getListProcessLearning(params)
        .then((response) => {
            commit(types.GET_LIST_PROCESS_LEARNING, response.data);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetDetailProcessLearningByDate = ({ commit }, params = {}) => {
    return api.getDetailProcessLearningByDate(params)
        .then((response) => {
            // commit(types.GET_LIST_PROCESS_LEARNING, response.data);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const actionGetListProcessChat = ({ commit }, params = {}) => {
    return api.getListProcessChat(params)
        .then((response) => {
            commit(types.GET_LIST_PROCESS_CHAT, response.data);
            return response.data
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const actionGetOverviewSubjectChart = ({ commit }, params = {}) => {
    return api.getOverviewSubjectChart(params)
        .then((response) => {
            let data = []
            if(response && response.data && response.data.length >0){
                response.data.map(item=>{
                    if(item.totalQuestion >0){
                        data.push(item)
                    }
                })
            }
            commit(types.GET_OVER_SUBJECT_CHART, data);

            return data
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const actionGetListActivityType = ({ commit }, params = {}) => {
    return api.getListActivityType(params)
        .then((response) => {
            // commit(types.GET_ALL_PROVICE, response.data);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

// const actionLibraryFilterData = ({ commit }, id) => {
//     alert("okokoko")
//     api.getLibraryFilterData(id)
//         .then((response) => {
//             commit(types.GET_USER_PROFILE, response.data);
//         })
//         .catch((error) => {
//             // eslint-disable-next-line
//             console.error(error);
//         });
// };

const actionUpdateLessonClass = ({ commit }, params = { data }) => {
    return api.updateLessonClass(params)
        .then((response) => {
            // commit(types.CLASS_SCHOOL_LIST_MEMBER, response.data);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionUpdateUserInfo = ({ commit }, params = { data }) => {
    return api.updateUserInfo(params)
        .then((response) => {
            // commit(types.CLASS_SCHOOL_LIST_MEMBER, response.data);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionUpdateParentInfo = ({ commit }, params = { data }) => {
    return api.updateParentInfo(params)
        .then((response) => {
            // commit(types.CLASS_SCHOOL_LIST_MEMBER, response.data);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const actionListMyEbook = ({ commit }, params = { data }) => {
    return api.getListMyEbook(params)
        .then((response) => {
            commit(types.MY_EBOOL_LIST, response.data);
            return response.data
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const actionHomeGetTimeTable = ({ commit }, params = {}) => {
    api.getHomeGetTimeTable(params)
        .then((response) => {
            commit(types.GET_HOME_TIME_TABLE, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetListClasses = ({ commit }, params = {}) => {
    api.getListClasses(params)
        .then((response) => {
            commit(types.GET_LIST_CLASSES, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetListBookType = ({ commit }, params = {}) => {
    api.getListBookType(params)
        .then((response) => {
            commit(types.GET_LIST_BOOK_TYPE, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const getUserProfileEdit = ({ commit }, params = {}) => {
    return api.getUserProfileEdit(params)
        .then((response) => {
            commit(types.GET_USER_PROFILE_EDIT, response.data);
            return response
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetUserInfo = (context, params = {}) => {
    api.getUserInfo(params)
        .then((res) => {
            if (res && res.data) {
                // Save data user profile
                const auth = getAuth() || {}
                saveAuth({ ...auth, ...res.data })
                // Update auth info
                context.rootState.auth.user = {...auth, ...res.data}
                // context.commit('auth/SET_AUTH', {...auth, ...res.data}, { root: true })
                context.commit(types.GET_USER_INFO, res.data)
            }
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetProcessPracticeChart = ({ commit }, params = {}) => {
    api.getProcessPracticeChart(params)
        .then((response) => {
            commit(types.GET_PROCESS_PRACTICE_CHART, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const actionGetBaseInfo = ({ commit }, params = {}) => {
    api.getBaseInfo(params)
        .then((response) => {
            commit(types.GET_BASE_INFO, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionActivityList = ({ commit }, params = {}) => {
 return   api.getActivityList(params)
        .then((response) => {
            commit(types.GET_ACTIVITY_LIST, response.data);
            return response.data
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const updateUserProfile = ({ commit }, payload = {}) => {
    api.updateUserProfile(payload)
        .then((response) => {
            if (response && response.status == 'success') {
                Vue.$toast.success('Cập nhật thành công!');

                let authInfo = getAuth();
                if (authInfo.firstLogin) {
                    saveAuth({...authInfo, ...payload, firstLogin: false });
                    router.push({ name: 'ebook' });
                } else {
                    router.push({ name: 'user-profile' });
                }
            }
            // return response;
            // if(response && response.status=='success') {
            //   // router.push({ name: 'user-profile'});
            // }
            // else{
            //    console.log('Errors '+JSON.stringify(response.errors))
            //    return false;
            // }
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionSetParamListEctricBooks = ({ commit }, data) => {
    return commit(types.SET_PARAM_LIST_BOOKS, data);
}
const setPramPracticeChart = ({ commit }, data) => {
    return commit(types.SET_PARAM_PRACTICE_CHART, data);
}
const setParamLearningProcess = ({ commit }, data) => {
    return commit(types.SET_PARAM_LEARNING_PROCESS, data);
}
const setParamListProcessChat = ({ commit }, data) => {
    return commit(types.SET_PARAM_LIST_PROCESS_CHAT, data);
}

const setParamActivityList = ({ commit }, data) => {
    return commit(types.SET_PARAM_ACTIVITY_LIST, data);
}
const actionSetPracticeCurr = ({ commit }, data) => {
    commit(types.SET_PACTICE_ACTIVE, data);
}
const setDispalyDetail = ({ commit }, data) => {
    commit(types.SET_DISPALY_DETAIL, data);
}
const setChangDislay = ({ commit }, data) => {
    commit(types.SET_CHANG_CLASS, data);
}

export default {
    getUserProfile,
    getUserProfileEdit,
    updateUserProfile,
    actionHomeGetTimeTable,
    actionUpdateLessonClass,
    actionGetUserInfo,
    actionGetBaseInfo,
    actionSetParamListEctricBooks,
    actionListMyEbook,
    actionGetListClasses,
    actionGetListBookType,
    actionUpdateUserInfo,
    actionUpdateParentInfo,
    actionSetPracticeCurr,
    setParamActivityList,
    actionActivityList,
    actionGetAllProvince,
    actionGetListActivityType,
    actionGetListTypeSchool,
    actionGetTypePractice,
    actionGetBookGroup,
    actionGetSubjects,
    setPramPracticeChart,
    actionGetProcessPracticeChart,
    setParamLearningProcess,
    actionGetListProcessLearning,
    actionGetOverviewSubjectChart,
    setParamListProcessChat,
    actionGetListProcessChat,
    actionGetDetailProcessLearningByDate,
    setDispalyDetail,
    setChangDislay
};